module.exports = __webpack_public_path__ + "img/883fa10.jpg";